import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function SelectSchool() {
  const { allowedSchools, activeSchoolId, setActiveSchoolId, signOut } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (activeSchoolId) {
      navigate('/', { replace: true })
    }
  }, [activeSchoolId, navigate])

  return (
    <div dir="rtl" style={{ maxWidth: 520, margin: '2rem auto', padding: 16, display: 'grid', gap: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0 }}>اختر المدرسة</h2>
        <button onClick={signOut} style={btnSecondary}>تسجيل الخروج</button>
      </div>

      {allowedSchools?.length ? (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden', background: '#fff' }}>
          {allowedSchools.map(s => (
            <button
              key={s.school_id}
              onClick={() => setActiveSchoolId(Number(s.school_id))}
              style={{
                width: '100%',
                textAlign: 'right',
                padding: 12,
                border: 'none',
                background: Number(activeSchoolId) === Number(s.school_id) ? '#eff6ff' : '#fff',
                borderBottom: '1px solid #f3f4f6',
                cursor: 'pointer',
              }}
            >
              <div style={{ fontWeight: 700 }}>{s.school_name}</div>
              <div style={{ fontSize: 12, color: '#6b7280' }}>{s.role}</div>
            </button>
          ))}
        </div>
      ) : (
        <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', padding: 12, borderRadius: 10 }}>
          لا توجد مدارس مرتبطة بهذا الحساب.
        </div>
      )}
    </div>
  )
}

const btnSecondary = {
  padding: '8px 12px',
  borderRadius: 8,
  border: '1px solid #d1d5db',
  background: '#fff',
  color: '#374151',
  cursor: 'pointer',
}
